import { Dispatch, SetStateAction, useEffect, useRef } from "react";

export const useFixedColumnWidths = (
  columnId: string,
  fixedColumnIds: { value: string }[] | undefined,
  setFixedColumnWidths: Dispatch<SetStateAction<number[]>>,
) => {
  const headerRef = useRef<HTMLTableCellElement | null>(null);

  useEffect(() => {
    if (headerRef.current) {
      const width = headerRef.current.offsetWidth;

      if (fixedColumnIds?.some((id) => id.value === columnId)) {
        setFixedColumnWidths((prevWidths: number[]) => {
          const newWidths = [...prevWidths];
          const columnIndex = fixedColumnIds.findIndex(
            (id) => id.value === columnId,
          );
          newWidths[columnIndex] = width;
          return newWidths;
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return headerRef;
};
